import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("SurveyManagerPermissions")
export class SurveyManagerPermissions {
  static readonly None = 0;
  static readonly Create = 1;
  static readonly Edit = 2;
  static readonly Delete = 4;
}
